import { useRef } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Box, Button, Flex, Heading, Text } from "@chakra-ui/react";
import { FaArrowRight, FaEnvelope } from "react-icons/fa6";
import { useReveal } from "../hooks/landingEffects";

const FinalCta = () => {
  const ref = useRef(null);
  useReveal(ref);

  return (
    <Box
      ref={ref}
      className="lp-reveal"
      as="section"
      mt="100px"
      mb="60px"
      mx="auto"
      maxW="1240px"
      px="24px"
    >
      <Box
        borderRadius="26px"
        px="40px"
        py="50px"
        sx={{
          background: `
            linear-gradient(135deg, rgba(4,174,193,0.25), rgba(99,102,241,0.28) 50%, rgba(236,72,153,0.22)),
            linear-gradient(180deg, rgba(10,14,26,0.7), rgba(15,22,38,0.65)),
            url('/navbar_bg.png') center/cover no-repeat
          `,
        }}
        border="1px solid rgba(255,255,255,0.16)"
        textAlign="center"
        position="relative"
        overflow="hidden"
        boxShadow="0 30px 70px -20px rgba(99,102,241,0.45)"
        _before={{
          content: '""',
          position: "absolute",
          borderRadius: "50%",
          filter: "blur(60px)",
          pointerEvents: "none",
          width: "320px",
          height: "320px",
          background: "rgba(255,255,255,0.18)",
          top: "-120px",
          left: "-80px",
        }}
        _after={{
          content: '""',
          position: "absolute",
          borderRadius: "50%",
          filter: "blur(60px)",
          pointerEvents: "none",
          width: "360px",
          height: "360px",
          background: "rgba(236,72,153,0.4)",
          bottom: "-160px",
          right: "-100px",
        }}
      >
        <Heading
          as="h2"
          fontSize="clamp(28px, 3.6vw, 44px)"
          fontWeight={700}
          letterSpacing="-0.02em"
          mb="12px"
          color="white"
          textShadow="0 2px 8px rgba(0,0,0,0.15)"
          position="relative"
          zIndex={1}
        >
          Stop chasing CSVs.
          <br />
          Start shipping smarter.
        </Heading>
        <Text
          fontSize="15px"
          color="rgba(255,255,255,0.85)"
          maxW="540px"
          mx="auto"
          mb="24px"
          lineHeight="1.55"
          position="relative"
          zIndex={1}
        >
          Plug in your retailer feeds and we'll have your first dashboard live
          in under a week. No long contracts, no setup fees.
        </Text>
        <Flex justify="center" gap="12px" wrap="wrap" position="relative" zIndex={1}>
          <Button
            as={RouterLink}
            to="/contact-us"
            variant="unstyled"
            display="inline-flex"
            alignItems="center"
            gap="8px"
            bg="white"
            color="#0a0e1a"
            borderRadius="9999px"
            fontSize="14px"
            fontWeight={600}
            px="24px"
            py="13px"
            h="auto"
            transition="all 0.25s cubic-bezier(0.34, 1.56, 0.64, 1)"
            _hover={{
              transform: "translateY(-2px)",
              bg: "white",
              color: "#0a0e1a",
              boxShadow: "0 14px 32px -10px rgba(255,255,255,0.4)",
            }}
          >
            Book a demo
            <FaArrowRight size={11} />
          </Button>
          <Button
            as={RouterLink}
            to="/contact-us"
            variant="unstyled"
            display="inline-flex"
            alignItems="center"
            gap="8px"
            bg="transparent"
            color="white"
            border="1px solid rgba(255,255,255,0.4)"
            borderRadius="9999px"
            fontSize="14px"
            fontWeight={600}
            px="24px"
            py="13px"
            h="auto"
            transition="all 0.25s cubic-bezier(0.34, 1.56, 0.64, 1)"
            _hover={{
              bg: "rgba(255,255,255,0.1)",
              color: "white",
              transform: "translateY(-1px)",
            }}
          >
            <FaEnvelope size={11} />
            Talk to us
          </Button>
        </Flex>
      </Box>
    </Box>
  );
};

export default FinalCta;
